import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import { Maybe, PolicyStackAttachment } from "types/generated";

import { DETACH_POLICY_FROM_ENTITY } from "./gql";

const useDetachPolicy = (refetchQueries?: string[]) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const [detachPolicy, { loading }] = useMutation<{ policyDetach: Maybe<PolicyStackAttachment> }>(
    DETACH_POLICY_FROM_ENTITY,
    {
      refetchQueries,
      awaitRefetchQueries: true,
    }
  );

  const handleDetachPolicy = useCallback(
    (attachmentId: string, successCallback?: () => void) => {
      detachPolicy({ variables: { attachmentId } })
        .then(({ data }) => {
          if (data?.policyDetach) {
            reportSuccess({
              message: "Policy was successfully detached",
            });
            successCallback?.();
          }
        })
        .catch(onError);
    },
    [detachPolicy, onError, reportSuccess]
  );

  return {
    detachPolicy: handleDetachPolicy,
    loading,
  };
};

export default useDetachPolicy;
